import { FC } from 'react';
import { Box, Image, Heading, Badge, theme, Gap } from '@salecycle/ui-component-library';
import { LogoBox } from 'sections/client-management/ui/pages/client-settings/tracking-links/components/styles';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ILinkConfig } from 'sections/design/template-management/entities/link-config';

interface Props {
  link: ILinkConfig;
}

const LinkInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  white-space: nowrap;
`;

export const TrackingTile: FC<Props> = ({ link }) => {
  const { t } = useTranslation('trackingLinks');
  const { siteId } = useParams<{ siteId: string }>();
  return (
    <Box data-testid={`TrackingTile-${link.kind}`}>
      <LogoBox>
        <Image size={50} src={`/images/tracking_links_type/${link.kind}.svg`} />
      </LogoBox>
      <Gap left={20} />
      <LinkInformation>
        <Heading variation="h4">{t('trackingLinks:settings.types.' + link.kind)} Tracking</Heading>
        <Badge
          color={link.isActive ? theme.vars.newColor.green2 : theme.vars.newColor.darkGS3}
          icon="cog"
          onClick={() => window.open(`/sites/${siteId}/settings/tracking-links/edit/${link.ownerId}/${link.kind}`)}
        >
          {t('trackingLinks:templateLevel.leftPanel.site')}{' '}
          {link.isActive
            ? t('trackingLinks:templateLevel.leftPanel.on')
            : t('trackingLinks:templateLevel.leftPanel.off')}
        </Badge>
      </LinkInformation>
      <Gap left={40} />
    </Box>
  );
};
